import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import claraLeve from '../assets/clara_leve.png';
import claraOuvert from '../assets/clara_ouvert.png';

const css = `
  .wl { position: fixed; inset: 0; z-index: 400; background: #F6F2EC; display: flex; justify-content: center; font-family: 'Inter', system-ui, sans-serif; color: #222; overflow-y: auto; }
  .wl-in { width: 100%; max-width: 440px; padding: 18px 22px 26px; display: flex; flex-direction: column; min-height: 100%; }
  .wl-skip { align-self: flex-end; background: none; border: 0; font-size: 14px; font-weight: 700; color: #6b6b64; min-height: 44px; padding: 0 4px; cursor: pointer; font-family: inherit; }
  .wl-dots { display: flex; gap: 6px; justify-content: center; margin: 4px 0 20px; }
  .wl-dots i { width: 24px; height: 5px; border-radius: 3px; background: #E3DCCF; } .wl-dots i.on { background: #E4572E; }
  .wl-ill { background: #173B34; border-radius: 22px; min-height: 200px; margin-bottom: 22px; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; padding: 22px; color: #F6F2EC; }
  .wl-av { width: 84px; height: 84px; border-radius: 50%; background: #fff center 15% / 140% no-repeat; border: 3px solid #F6F2EC; margin-bottom: 12px; }
  .wl-ill b { font-size: 19px; line-height: 1.3; } .wl-ill span { font-size: 13.5px; opacity: .85; margin-top: 8px; line-height: 1.45; }
  .wl h2 { font-size: 26px; line-height: 1.15; color: #173B34; margin: 0 0 10px; font-weight: 800; letter-spacing: -.01em; }
  .wl p { font-size: 15.5px; line-height: 1.55; color: #444; margin: 0 0 14px; }
  .wl-spacer { flex: 1; min-height: 16px; }
  .wl-btn { display: flex; align-items: center; justify-content: center; width: 100%; min-height: 54px; border: 0; border-radius: 14px; background: #E4572E; color: #fff; font-size: 16.5px; font-weight: 700; font-family: inherit; cursor: pointer; }
  .wl-chk { display: flex; gap: 12px; align-items: center; background: #fff; border: 1px solid #E3DCCF; border-radius: 12px; padding: 13px; margin-bottom: 9px; font-size: 15px; line-height: 1.35; }
  .wl-chk i { width: 24px; height: 24px; border-radius: 12px; flex: none; border: 2px solid #E3DCCF; background: #fff; }
  .wl-chk.ok i { background: #173B34; border-color: #173B34; color: #fff; font-style: normal; text-align: center; line-height: 20px; font-size: 13px; }
`;

const cle = (email) => `bs_welcome_${email}`;

// Affiche le bandeau de bienvenue une seule fois, à la première visite d'un compte qui n'a pas encore commencé
export function WelcomeOnboarding() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [done, setDone] = useState(() => {
    try { return !!localStorage.getItem(cle(user?.email)); } catch (e) { return true; }
  });
  if (!user || user.isAdmin || done || (user.moduleActuel || 1) > 1) return null;

  const fermer = (vers) => {
    try { localStorage.setItem(cle(user.email), '1'); } catch (e) {}
    setDone(true);
    if (vers) navigate(vers);
  };

  const ecrans = [
    {
      ill: (<><div className="wl-av" style={{ backgroundImage: `url(${claraLeve})` }} /><b>Bienvenue sur BrandStarter, {user.prenom}</b><span>Ton compte est activé, tu as {user.joursRestants || 20} jours devant toi.</span></>),
      titre: 'On construit ta marque, étape par étape',
      texte: 'Tu as cinq modules pour poser ton idée, ton client idéal, ta raison d\'être, ton positionnement et ta voix. Chaque module te rend une fiche à garder.'
    },
    {
      ill: (<><div className="wl-av" style={{ backgroundImage: `url(${claraOuvert})` }} /><b>Clara te guide</b><span>Elle te pose les questions, challenge tes réponses et se souvient de tout.</span></>),
      titre: 'Tu ne remplis pas un formulaire, tu discutes',
      texte: 'Réponds avec tes mots, même approximatifs. Quand tu manques d\'inspiration, touche une réponse rapide proposée par Clara.'
    }
  ];

  const dernier = step === 2;
  return (
    <>
      <style>{css}</style>
      <div className="wl" role="dialog" aria-modal="true" aria-label="Bienvenue">
        <div className="wl-in">
          {!dernier ? <button className="wl-skip" onClick={() => fermer()}>Passer</button> : <span style={{ minHeight: 44 }} />}
          <div className="wl-dots">{[0, 1, 2].map(i => <i key={i} className={i === step ? 'on' : ''} />)}</div>
          {!dernier ? (
            <>
              <div className="wl-ill">{ecrans[step].ill}</div>
              <h2>{ecrans[step].titre}</h2>
              <p>{ecrans[step].texte}</p>
              <div className="wl-spacer" />
              <button className="wl-btn" onClick={() => setStep(step + 1)}>Suivant</button>
            </>
          ) : (
            <>
              <h2>Ton plan pour aujourd'hui</h2>
              <p>Dix minutes suffisent pour commencer.</p>
              <div className="wl-chk ok"><i>&#10003;</i>Compte activé</div>
              <div className="wl-chk"><i />Module 1 : poser ton idée (environ 10 minutes)</div>
              <div className="wl-chk"><i />Voir ta page Ma marque se remplir</div>
              <div className="wl-chk"><i />Écrire à Dany si tu bloques (icône de message en haut à droite)</div>
              <div className="wl-spacer" />
              <button className="wl-btn" onClick={() => fermer('/module/1')}>Commencer le module 1</button>
            </>
          )}
        </div>
      </div>
    </>
  );
}
